import { Box, Stepper, Step, StepLabel, Button, Container } from "@mui/material";
import { Header } from "../Header";
import React, { useState } from "react";
import { Loading } from "../Loading";
import { ChooseProduct } from "./ChooseProduct";
import { OrderDetails } from "../OrderDetails";
import { useNavigate } from "react-router-dom";
import { Produto } from "../../models/notouch/produto";

const steps = ['Escolha o produto', 'Detalhes do pedido'];

export const Purchase = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [showLoading, setShowLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<Produto | undefined>(undefined);
  const navigate = useNavigate();

  const handleNext = () => {
    setShowLoading(true);
    setTimeout(() => {
      setShowLoading(false);
      setActiveStep(1);
    }, 1000);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSelectProduct = (product: Produto) => {
    setSelectedProduct(product);
    handleNext();
  };

  const handleGoToHistory = () => {
    navigate("/historico");
  };

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <ChooseProduct selectedProduct={selectedProduct} handleSelectProduct={handleSelectProduct} />;
      case 1:
        return <OrderDetails selectedProduct={selectedProduct}/>;
      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {getStepContent(activeStep)}
        
        <Box sx={activeStep === 0 ? {display: 'flex', justifyContent: 'center', pt: 4} : {display: 'flex', justifyContent: 'start', pt: 2}}>
          <Button 
            variant="contained" 
            color="primary"
            onClick={() => activeStep === 0 ? handleGoToHistory() : handleBack()}>
            {activeStep === 0 ? "Voltar para Inicio" : "Voltar"}
          </Button>
        </Box>
      </Container>
      <Loading mode="blurry" hidden={!showLoading} />
    </>
  );
};